import { resumeData } from '../data/resumeData';

export default function Footer() {
  const { meta } = resumeData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-4 px-6 bg-black border-t border-gray-800">
      <div className="container mx-auto flex flex-col md:flex-row justify-center items-center">
        <p className="text-sm mb-4 md:mb-0 text-gray-300">
          © {currentYear} {meta.name}. All rights reserved.
        </p>
        {/* <div className="flex space-x-6">
          <a
            href={meta.social.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-300 hover:text-primary transition-colors"
          >
            LinkedIn
          </a>
          <a
            href={meta.social.portfolio}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-300 hover:text-primary transition-colors"
          >
            Portfolio
          </a>
          <a
            href={`mailto:${meta.email}`}
            className="text-sm text-gray-300 hover:text-primary transition-colors"
          >
            Email
          </a>
        </div> */}
      </div>
    </footer>
  );
}